import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiClient } from '@/lib/apiClient'
import { API_ROUTES } from '@/constants/apiRoutes'
import { CardList, CardState } from '@/types/index'

export const getCards = createAsyncThunk<CardState>(API_ROUTES.ADMIN_CARD_ENDPOINT, async () => {
  const res = await apiClient.get<CardState>(API_ROUTES.ADMIN_CARD_ENDPOINT)
  const data = (res as any).data ? (res as any).data : res   // hỗ trợ trường hợp apiClient bọc data
  return data
})
const initialState: CardList = {
  cards: [],
  loading: false,
  error: null,
}

const adminCardSlice = createSlice({
  name: 'adminCard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET CARDS
      .addCase(getCards.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getCards.fulfilled, (state, action) => {
        state.cards = action.payload.items
        state.loading = false
      })
      .addCase(getCards.rejected, (state, action) => {
        state.error = action.error.message || 'Error'
        state.loading = false
      })
  },
})

export default adminCardSlice.reducer
